import { axios } from '@Root/API'

export const edit = (studyProgrammeId, fundingBodyId, payload) => {
	return axios.post(`course-session/${studyProgrammeId}/funding-body/${fundingBodyId}`, payload)
}
